import TeamContext from "../../common/context/team-context";

export default class TennisTeamContext extends TeamContext {
    constructor(teamId) {
        super(teamId);

        this.single = [];
        this.doubles = [];
    }

    isSingle(player) {
        return this.single.indexOf(player.id) >= 0;
    }

    addSingle(player) {
        if (player.id && !this.single.includes(player.id)) {
            this.single.push(player.id);
        }
    }

    removeSingle(player) {
        this.single = this.single.filter((p) => p !== player.id);
    }

    isDoubles(player) {
        return this.doubles.indexOf(player.id) >= 0;
    }

    addDoubles(player) {
        if (player.id && !this.doubles.includes(player.id)) {
            this.doubles.push(player.id);
        }
    }

    removeDoubles(player) {
        this.doubles = this.doubles.filter((p) => p !== player.id);
    }
}
